import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { posthog } from '@/analytics/posthog'

export const PostHogRouterTracker = () => {
  const location = useLocation()

  useEffect(() => {
    if (import.meta.env.PROD) {
      posthog.capture('$pageview', {
        $current_url: window.location.href,
        pathname: location.pathname,
        search: location.search,
      })
    }
  }, [location])

  return null
}